module.exports = __webpack_public_path__ + "static/media/51-kauai.ff32e79f.jpeg";